/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo } from 'react';
import { EmojiEvents } from '@mui/icons-material';
import { generatePath, useParams } from 'react-router';

import useUser from '@/hooks/useUser';
import theme from '@/constants/theme';
import { routes } from '@/constants/routes';
import HeaderNavigation from '@/components/navigation/HeaderNavigation';

import useLoadContent from './useLoadContent';
import CompleteContentPlaceholder from './placeholder';
import useCompleteContent from './useCompleteContent';
import CompleteContentCover from '@/components/routes/CompleteContentCover';
import { UserResponses } from '@/components/interactive/Quiz/common';

const CompleteContent = () => {
  const { user } = useUser();
  const { routeId, contentId } = useParams();
  const { loading, content } = useLoadContent({ routeId, contentId });
  useCompleteContent({ routeId, contentId, content });

  const parsedUserResponses = useMemo(() => {
    if (!content?.quizResponses) return null;
    return JSON.parse(content?.quizResponses) as UserResponses;
  }, [content?.quizResponses]);

  const shouldGenerateAnalysis = useMemo(() => {
    if (!parsedUserResponses) return false;
    return !Boolean(parsedUserResponses.analysis) && content?.type === 'QUIZ' && content?.hasAnalysisPrompt;
  }, [parsedUserResponses, content?.type]);

  const overviewData = useMemo(() => JSON.parse(content?.overviewData ?? '{}'), [content?.overviewData]);

  if (loading) return <CompleteContentPlaceholder />;

  return (
    <div
      style={{
        flex: 1,
        backgroundColor: theme.colors.background.primary,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        maxHeight: '100%',
      }}
    >
      <HeaderNavigation
        loading={loading}
        title={content?.title!}
        backHref={generatePath(routes.routes.detail, { routeId })}
        rightContent={
          <p
            style={{
              color: theme.colors.primary,
              fontSize: 16,
              display: 'flex',
              gap: 4,
              alignItems: 'center',
            }}
          >
            {user?.points ?? 0}
            <EmojiEvents />
          </p>
        }
      />
      <CompleteContentCover
        routeId={routeId}
        title={content?.title!}
        emoji={overviewData?.emoji}
        benefits={overviewData?.benefits}
        analysis={parsedUserResponses?.analysis}
        shouldGenerateAnalysis={shouldGenerateAnalysis}
        contentInteractionId={content?.contentInteractionId}
      />
    </div>
  );
};

export default CompleteContent;
